import { isSourceKeyFormat } from '@/utils/number';
import { getImageObject, getLayerRecolorEnabled, getRefName } from '../utils';
import { ShapeType } from '@/services/shape';

export function DataItemPointerLayerHandler(
  resAst: Ast,
  layerAst: Ast,
  layer: StoreLayerItem,
  colors: StoreThemeColorItem[]
) {
  layer.attrs.resources = {
    pointer0: getImageObject(resAst, getRefName(layerAst.attrsMap.ref), colors)
  };

  const _angleStart = Number(layerAst.attrsMap.angleStart);
  layer.attrs.angleStart = _angleStart;
  const _angleRange = Number(layerAst.attrsMap.angleRange);
  layer.attrs.angleEnd = _angleStart + _angleRange;

  layer.attrs.valueStart = isSourceKeyFormat(layerAst.attrsMap.valueStart)
    ? layerAst.attrsMap.valueStart
    : Number(layerAst.attrsMap.valueStart);
  layer.attrs.valueEnd = isSourceKeyFormat(layerAst.attrsMap.valueRange)
    ? layerAst.attrsMap.valueRange
    : Number(layerAst.attrsMap.valueRange) +
      Number(layerAst.attrsMap.valueStart);

  layer.attrs.sourceEnabled = layerAst.attrsMap.source != undefined;
  layer.attrs.recolorEnabled = getLayerRecolorEnabled(
    resAst,
    getRefName(layerAst.attrsMap.ref)
  );
  layer.attrs = { ...layerAst.attrsMap, ...layer.attrs };
  layer.type = ShapeType.Image;
  if (layerAst.attrsMap.renderRule == 'hideWhenOutRange') {
    layer.attrs._hideWhenOutRange = true;
  }
}
